var map = {
	"./admin-1.jpg": 40538,
	"./background-bs.png": 9501,
	"./bg-login.jpg": 80688,
	"./bg-login.png": 69844,
	"./bg-login.svg": 26902,
	"./bg-warranty-bswm-status.png": 44620,
	"./blue-scope-logo.png": 55052,
	"./building-isometric-disabled.png": 71784,
	"./building-isometric.png": 64441,
	"./customer-1.jpg": 84503,
	"./footer-created-verify-qr-en.png": 86053,
	"./footer-created-verify-qr-landscape-en.png": 38309,
	"./footer-created-verify-qr-landscape-th.png": 87960,
	"./footer-created-verify-qr-square-en.png": 34449,
	"./home-isometric-disabled.png": 54431,
	"./home-isometric.png": 75200,
	"./licence.png": 65940,
	"./license.jpg": 56448,
	"./mockup-google-map.jpg": 75151,
	"./news-promotion-cover-1.jpg": 51328,
	"./news-promotion-cover-2.jpg": 17967,
	"./news-promotion-cover-3.jpg": 41586,
	"./news-promotion-cover-4.jpg": 69633,
	"./news-promotion-cover-5.jpg": 91588,
	"./news-promotion-cover-6.jpg": 75283,
	"./news-promotion-cover-7.jpg": 20022,
	"./news-promotion-cover-8.jpg": 80133,
	"./news-promotions-banner-1.jpg": 28996,
	"./news-promotions-banner-2.jpg": 55219,
	"./qr-code-preview-template.png": 62868,
	"./qr-code.jpg": 42252,
	"./reward-redemption-1.jpg": 40966,
	"./segment-residential.png": 63227,
	"./warranty-bs-logo.png": 27477,
	"./warranty-bs-watermark.png": 64120,
	"./warranty-footer-indonesia.png": 30096,
	"./warranty-footer-malaysia.png": 34645,
	"./warranty-footer-thailand-th.png": 93268,
	"./warranty-footer-thailand.png": 5257,
	"./warranty-footer-vietnam.png": 90522,
	"./warranty-header-indonesia-P13XL_COLORBOND_R_XAL.png": 42955,
	"./warranty-header-indonesia-P13XP_COLORBOND_R_XPD.png": 51180,
	"./warranty-header-indonesia-P17UL_COLORBOND_R_ULTRA.png": 94233,
	"./warranty-header-indonesia-P17XR_COLORBOND_R_XRW.png": 59503,
	"./warranty-header-indonesia-P1CCP_COLORBOND_R_COOLROOM.png": 56887,
	"./warranty-header-indonesia-P1CCP_CRP_ANTIBACTERIAL.png": 53786,
	"./warranty-header-indonesia-P2BPC_BLUESCOPE_ZACS_COOL.png": 153,
	"./warranty-header-indonesia-P2BPN_BLUESCOPE_ZACS_NATURAL.png": 21948,
	"./warranty-header-indonesia-P2CCT_CRP_FOODGRADE.png": 68389,
	"./warranty-header-indonesia-P2HRP_HRP_ANTIBACTERIAL.png": 4736,
	"./warranty-header-indonesia-P2KIR_KIRANA.png": 70138,
	"./warranty-header-indonesia-Z1TRC_TRUECORE.png": 66679,
	"./warranty-header-indonesia-Z1ZAL_ZINCALUME.png": 79432,
	"./warranty-header-indonesia-Z1ZAU_ZINCALUME_ULTRA.png": 70066,
	"./warranty-header-indonesia-Z2ABD_ABADI.png": 40452,
	"./warranty-header-indonesia-Z2BZC_BLUESCOPE_ZACS_BARE.png": 36926,
	"./warranty-header-indonesia-Z2BZU_BLUESCOPE_ZACS_TRUSS.png": 37279,
	"./warranty-header-malaysia-CAPERO_MY_P1CWR.png": 9603,
	"./warranty-header-malaysia-CCB_MATT_MY_P15RM.png": 42466,
	"./warranty-header-malaysia-CCB_SPECTRUM_MY_P15PP.png": 8632,
	"./warranty-header-malaysia-CCB_SPECTRUM_MY_P1CPP.png": 15598,
	"./warranty-header-malaysia-CCB_ULTRA_MATT_MY_P15UM.png": 88976,
	"./warranty-header-malaysia-CCB_ULTRA_MY_P15UL.png": 52478,
	"./warranty-header-malaysia-CCB_XPD_MY_P15XP.png": 36963,
	"./warranty-header-malaysia-CCB_XPD_PSC_MY_P15XS.png": 46057,
	"./warranty-header-malaysia-CCB_XRW_MY_P15XR.png": 24086,
	"./warranty-header-malaysia-PM_MY_P2PRM.png": 84682,
	"./warranty-header-malaysia-PM_R_MY_P2PRJ.png": 64508,
	"./warranty-header-malaysia-TRUECORE_MY_Z1TRC.png": 94591,
	"./warranty-header-malaysia-VERMOE_MY_P1VRM.png": 67762,
	"./warranty-header-malaysia-ZL_MY_Z1ZAL.png": 7938,
	"./warranty-header-malaysia-ZL_MY_Z1ZAU.png": 84003,
	"./warranty-header-thailand-BLUESCOPE_ZACS_TH.png": 82037,
	"./warranty-header-thailand-COLORBOND_TH.png": 84095,
	"./warranty-header-thailand-CRP_ANTIBACTERIAL_SD_TH.png": 41366,
	"./warranty-header-thailand-ENDUROCORE_TH.png": 25695,
	"./warranty-header-thailand-JINGJOE_LEK_TH.png": 79138,
	"./warranty-header-thailand-PP_PANEL_SD_TH.png": 97392,
	"./warranty-header-thailand-PRIMA_TH.png": 76786,
	"./warranty-header-thailand-SUPERDYMA_TH.png": 51947,
	"./warranty-header-thailand-TRUECORE_TH.png": 44796,
	"./warranty-header-thailand-ZINCALUME_TH.png": 13269,
	"./warranty-header-vietnam-CCB_CUSTOM_XPD_PEARLESCENT_VN_P17XR.png": 82911,
	"./warranty-header-vietnam-CCB_CUSTOM_XPD_VN_P17XR.png": 1970,
	"./warranty-header-vietnam-CCB_FOR_PANEL_VN_P17XR.png": 84098,
	"./warranty-header-vietnam-CCB_FOR_PANEL_VN_P1CPP.png": 7564,
	"./warranty-header-vietnam-CCB_ULTRA_ACTIVATE_VN_P17XR.png": 96920,
	"./warranty-header-vietnam-CCB_ULTRA_ACTIVATE_VN_V13UL.png": 61471,
	"./warranty-header-vietnam-CCB_ULTRA_VN_P14UL.png": 13328,
	"./warranty-header-vietnam-CCB_XPD_PSC_VN_P13XS.png": 41488,
	"./warranty-header-vietnam-CCB_XPD_VN_X13XP.png": 418,
	"./warranty-header-vietnam-CCB_XRW_VN_P13XR.png": 96243,
	"./warranty-header-vietnam-HINATA_BARE_VN_Z1HB.png": 29898,
	"./warranty-header-vietnam-HINATA_PAINTED_VN_P1H1Z.png": 93428,
	"./warranty-header-vietnam-SUMO_ANTIFADING_VN_P17XR.png": 6003,
	"./warranty-header-vietnam-SUMO_ANTIFADING_VN_P2SUA.png": 50090,
	"./warranty-header-vietnam-SUMO_FOR_PANEL_VN_P3SUP.png": 54425,
	"./warranty-header-vietnam-ZL_ULTRA_VN_B1MAX.png": 82233,
	"./warranty-header-vietnam-ZL_ULTRA_VN_Z1ZAL.png": 62194,
	"./warranty-header-vietnam-ZL_VN_Z1ZAL.png": 62275,
	"./warranty-header-vietnam-bzacs-ben-lanh.png": 82292,
	"./warranty-header-vietnam-bzacs-ben-mau.png": 3560,
	"./warranty-header-vietnam-bzacs-hc-inok.png": 1008,
	"./warranty-header-vietnam-bzacs-inok.png": 5084,
	"./warranty-malaysia-terms-and-conditions-label.jpg": 99945,
	"./warranty-signature-malaysia.png": 21738,
	"./warranty-sub-header-en.png": 36794,
	"./warranty-sub-header-th.png": 77991,
	"./warranty-text-check-qr-en.png": 93566,
	"./warranty-text-check-qr.png": 65248,
	"./warranty-text-check-qr.svg": 22942,
	"./warranty_created_date_footer_en.jpeg": 13970,
	"./warranty_created_date_footer_th.jpeg": 44237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96943;